import * as React from "react";
import { cx } from "emotion";

import "./line-items-modules.scss";

import {cs}             from "@Common/react/chain-services";
import {itemEditor, ui} from "@Common/ui-components/heavy/item-options/modules/expo-types/expo-types";

import {lineItemsBaseModules} from "../../../common/line-items-modules/line-items-base-modules";
import {LineItems}            from "../../../common/line-items-modules/ui/line-items";

export const lineItemsModules = ({templateOptions, item}) => [
    ...lineItemsBaseModules({templateOptions, item}),
    {
        load: ({lineItems}, rootNext) => cs(
            ["lineItemsCard", ({}, next) => !lineItems.lineItems.length ? rootNext(null) : LineItems({
                item,
                lineItems: lineItems.lineItems,
                qrEnabled: lineItems.qrEnabled,
                selectedLineItems: lineItems.selectedLineItems,
                fullState    : lineItems.state,
                next,
            })],
            ({lineItemsCard}) => rootNext({
                itemEditor: lineItemsCard.itemEditor,
                ui: (
                    <div className={cx("line-items", "line-items-4ro")} xd-qa-type="card" xd-qa-name="Line Items">
                        {lineItemsCard.render?.()}
                    </div>
                ),
            }),
        ),
        expo: [ui("lineItems"), itemEditor],
        requires: ["lineItems"],
    },
];
